const ClientActions = {
	API_GET_CLIENTS_DATA: 'API_GET_CLIENTS_DATA',
	API_GET_CLIENTS_DATA_SUCCESS: 'API_GET_CLIENTS_DATA_SUCCESS',
	API_POST_CLIENT_DATA: 'API_POST_CLIENT_DATA',
	API_POST_CLIENT_DATA_SUCCESS: 'API_POST_CLIENT_DATA_SUCCESS',
	API_PUT_CLIENT_DATA: 'API_PUT_CLIENT_DATA',
	API_PUT_CLIENT_DATA_SUCCESS: 'API_PUT_CLIENT_DATA_SUCCESS',
	API_GET_CLIENT_DATA: 'API_GET_CLIENT_DATA',
	API_GET_CLIENT_DATA_SUCCESS: 'API_GET_CLIENT_DATA_SUCCESS',
	API_DELETE_CLIENT_DATA: 'API_DELETE_CLIENT_DATA',
	API_DELETE_CLIENT_DATA_SUCCESS: 'API_DELETE_CLIENT_DATA_SUCCESS',
	API_CLEAR_CLIENT_DATA: 'API_CLEAR_CLIENT_DATA',
	API_GET_SCOPES_PAGE_CLIENTS_DATA: 'API_GET_SCOPES_PAGE_CLIENTS_DATA',
	API_GET_SCOPES_PAGE_CLIENTS_DATA_SUCCESS: 'API_GET_SCOPES_PAGE_CLIENTS_DATA_SUCCESS',
	API_GET_SCOPES_LINK_TO_CLIENT: 'API_GET_SCOPES_LINK_TO_CLIENT',
	API_GET_SCOPES_LINK_TO_CLIENT_SUCCESS: 'API_GET_SCOPES_LINK_TO_CLIENT_SUCCESS',
	API_CLEAR_SCOPES_LINK_TO_CLIENT: 'API_CLEAR_SCOPES_LINK_TO_CLIENT',
	API_PUT_SCOPES_LINK_TO_CLIENT: 'API_PUT_SCOPES_LINK_TO_CLIENT',
	API_PUT_SCOPES_LINK_TO_CLIENT_SUCCESS: 'API_PUT_SCOPES_LINK_TO_CLIENT_SUCCESS',
	FETCHING_DATA: 'FETCHING_DATA',
	FETCHING_DATA_DONE: 'FETCHING_DATA_DONE',
	APP_SHOW_ALERT: 'APP_SHOW_ALERT',
	APP_HIDE_ALERT: 'APP_HIDE_ALERT',
	API_EXCHANGE_ACCESS_TOKEN: 'API_EXCHANGE_ACCESS_TOKEN',
	API_EXCHANGE_ACCESS_TOKEN_SUCCESS: 'API_EXCHANGE_ACCESS_TOKEN_SUCCESS',
	API_GET_SYSTEM_CONTEXTS: 'API_GET_SYSTEM_CONTEXTS',
	API_GET_SYSTEM_CONTEXTS_SUCCESS: 'API_GET_SYSTEM_CONTEXTS_SUCCESS',
	API_SAML_ASSERTION_TOKEN: 'API_SAML_ASSERTION_TOKEN',
	API_GET_SESSION_USER: 'API_GET_SESSION_USER',
	API_GET_SESSION_USER_SUCCESS: 'API_GET_SESSION_USER_SUCCESS',
	API_USER_LOGOUT: 'API_USER_LOGOUT'
};
export default ClientActions;
